export const userPath = `/user`
export const bootcampPath = `/bootcamp`
export const listPath = `/list`
